<template>
	<UiElement class="text-uppercase" tag="button" :settings="settings" @click="changeLanguage">
		{{ locale }}
	</UiElement>
</template>

<script setup>
	import { defineProps } from 'vue';
	import UiElement from '@/components/UI/UiElement.vue';
	import { storeToRefs } from 'pinia';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	defineProps({
		settings: {
			type: Object,
			required: true
		}
	});

	const translationsStore = useTranslationsStore();

	const { locale } = storeToRefs(translationsStore);

	function changeLanguage() {
		if (locale.value === 'en') {
			locale.value = 'cs';
		} else {
			locale.value = 'en';
		}
	}
</script>